var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon / calendar"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66602 0.833984C7.12625 0.833984 7.49935 1.20708 7.49935 1.66732V2.50065H12.4993V1.66732C12.4993 1.20708 12.8724 0.833984 13.3327 0.833984C13.7929 0.833984 14.166 1.20708 14.166 1.66732V2.50065H14.9993C16.8403 2.50065 18.3327 3.99304 18.3327 5.83398V15.0007C18.3327 16.8416 16.8403 18.334 14.9993 18.334H4.99935C3.1584 18.334 1.66602 16.8416 1.66602 15.0007V5.83398C1.66602 3.99304 3.1584 2.50065 4.99935 2.50065H5.83268V1.66732C5.83268 1.20708 6.20578 0.833984 6.66602 0.833984ZM12.4993 4.16732C12.4993 4.62755 12.8724 5.00065 13.3327 5.00065C13.7929 5.00065 14.166 4.62755 14.166 4.16732H14.9993C15.9198 4.16732 16.666 4.91351 16.666 5.83398V6.25065H3.33268V5.83398C3.33268 4.91351 4.07887 4.16732 4.99935 4.16732H5.83268C5.83268 4.62755 6.20578 5.00065 6.66602 5.00065C7.12625 5.00065 7.49935 4.62755 7.49935 4.16732H12.4993ZM16.666 7.91732H3.33268V15.0007C3.33268 15.9211 4.07887 16.6673 4.99935 16.6673H14.9993C15.9198 16.6673 16.666 15.9211 16.666 15.0007V7.91732Z",
    fill: "#667185"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarInactive);
export default __webpack_public_path__ + "static/media/calendar-inactive.5aafad4ee0fc6fc2499868e9ef5e18da.svg";
export { ForwardRef as ReactComponent };